import { atom } from "recoil";

export const blackListWithdrawalsAddModalStore = atom({
	key: "blackListWithdrawalsAddModalStore",
	default: {
		show: false,
		loaded: false,
		wallet: "",
		description: "",
		error: {
			text: "",
			code: 0,
			timestamp: 0,
		},
	},
});
